// CSS 

// Event, Dialog 

// Api
import api from '@/api/baseApi';

// Constant  
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { SETTINGS_RATING_API } from "@/constant/apiSettings";

// Extend
import base from '@/scripts/base';

// Component   

export default {

    extends: base,

    components: {
    },

    data() {
        return {
        };
    },

    methods: {
        matomoLog(Category, Action, Name, Value) {
            if(window.matomoEnabled){
                try {
                    let dataPush = ['trackEvent', Category, Action, Name];
                    if (Value) dataPush.push(Value);
                    if(window._paq) window._paq.push(dataPush);
                } catch (err) {
                    console.error(err);
                }
            }
        },
        //#region Rating submit
        ratingSubmit(data, callBack) {
            api.baseRequest(SETTINGS_RATING_API.RATING_SUBMIT, data)
                .then(() => {
                    this.notificationSuccess('Success !', 'Thank you for your rating of our service.');
                    if (callBack) callBack();
                    this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                })
                .catch(error => {
                    this.processCatchApiRequest(error, "Request failed ...")
                });
        },
        //#endregion
    },
}